query CountDidsForSwitch($queryList: [QueryItemInput!]) {
  countDids(queryList: $queryList) {
    count
  }
}
